import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import { AdditionItemIcon } from './item-icon/AdditionItemIcon';
import { AdditionItemImage } from './item-image/AdditionItemImage';
import { themes } from './Addition.themes';
export type AdditionItemProps = {
  icon?: {
    alt?: string;
    name: IconName;
  };
  image?: {
    alt?: string;
    src: string;
  };
  label?: string;
  link?: DynamicLinkProps;
};
type AdditionProps = {
  className?: string;
  items: Array<AdditionItemProps>;
  ratioKey?: MediaRatios;
  theme?: keyof typeof themes;
};
export const Addition = ({ className, items = [], ratioKey, theme = 'default' }: AdditionProps) => {
  const filteredItems = items.filter(({ icon = {}, image = {} }) => icon.name || image.src);

  if (!filteredItems.length) {
    return null;
  }

  const { thItem, thList, thSymbol } = themes[theme];
  const width = 100 / filteredItems.length;
  return (
    <ul className={classnames(thList, className)}>
      {filteredItems.map(({ icon = {}, image, label, link = {} }, idx) => {
        const isLink = !!link.url;
        const TagName = isLink ? DynamicLink : Fragment;
        const tagProps = isLink ? { ...link, className: 'block' } : null;
        const symbol =
          idx < filteredItems.length - 1 ? (
            <div className={thSymbol}>{idx === filteredItems.length - 2 ? '=' : '+'}</div>
          ) : null;
        return (
          <li className={thItem} key={label}>
            <TagName {...tagProps}>
              {icon.name ? (
                <AdditionItemIcon
                  alt={icon.alt}
                  iconName={icon.name}
                  label={label}
                  ratioKey={ratioKey}
                  symbol={symbol}
                  theme={theme}
                />
              ) : (
                <AdditionItemImage
                  image={image}
                  label={label}
                  ratioKey={ratioKey}
                  ratioDisplay={width / 100}
                  symbol={symbol}
                  theme={theme}
                />
              )}
            </TagName>
          </li>
        );
      })}
    </ul>
  );
};
